export default "__VITE_ASSET__Dzh8FFpR__"